/** Constants for MARKERS on map */
const MARKER_COUNTRIES = [
  'JEY',
  'GGY',
  'IMN',
  'GBR',
  'UKR',
  'TUR',
  'CHE',
  'SWE',
  'ESP',
  'SVK',
  'SVN',
  'SRB',
  'RUS',
  'ROU',
  'PRT',
  'POL',
  'NOR',
  'NLD',
  'MNE',
  'MDA',
  'MLT',
  'MKD',
  'LUX',
  'LTU',
  'LIE',
  'LVA',
  'KOS',
  'ITA',
  'IRL',
  'ISL',
  'HUN',
  'GRC',
  'DEU',
  'GEO',
  'FRA',
  'ALD',
  'FIN',
  'EST',
  'FRO',
  'DNK',
  'CZE',
  'CYN',
  'CYP',
  'HRV',
  'BGR',
  'BIH',
  'BEL',
  'BLR',
  'AUT',
  'ALB',
];

export {
  MARKER_COUNTRIES,
};



// WEBPACK FOOTER //
// ./src/maps/constants.js